mem.format = {
  padLeft: function (str, size, padChar) {
    return str.length >= size ?
      str :
      Array(1 + size - str.length).join(padChar || '0') + str;
  },

  time: function (ms) {
    var seconds = ms/1000,
      minutes = seconds/60,
      hours = minutes/60;

    function formatTime(digit) {
      return mem.format.padLeft(Math.floor(digit).toString(), 2);
    }

    return Math.floor(hours) + ':' +
      (formatTime(minutes % 60)) + ':' +
      (formatTime(seconds % 60));
  }
};
